module.exports = __webpack_public_path__ + "static/media/s2.1d779837.png";